import { render, staticRenderFns } from "./ClassManageView.vue?vue&type=template&id=06968282&scoped=true&"
import script from "./ClassManageView.vue?vue&type=script&lang=js&"
export * from "./ClassManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06968282",
  null
  
)

export default component.exports